import styled, { css } from "styled-components"
import { Box } from "@components/Layout"

export const FormWrap = styled(Box)<{ isLoading: boolean }>`
  opacity: 1;
  transition: opacity 0.3s ease-in-out;

  ${(p) =>
    p.isLoading &&
    css`
      opacity: 0.3;
      pointer-events: none;
    `}
`

export const ButtonContent = styled(Box)<{ success: boolean }>`
  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 50%);
    opacity: 0;
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);

    ${(p) =>
      p.success &&
      css`
        transform: translate(-50%, -50%);
        opacity: 1;
      `}
  }

  span {
    position: absolute;
    width: 100%;
    left: 0;
    top: 50%;
    opacity: 1;
    transform: translateY(-50%);
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);

    ${(p) =>
      p.success &&
      css`
        transform: translateY(50%);
        opacity: 0;
      `}
  }
`
